import { useEffect, useState } from 'react'
import to from 'await-to-js'
import { toast } from 'react-toastify'
import apiService from 'services/api'
import { CalendarOption } from 'services/calendarsApi'

interface UseCalendarsResult {
  calendars: CalendarOption[]
  selectedId: number | null
  setSelectedId: (id: number | null) => void
  loading: boolean
}

export function useCalendars(
  integrationId: number | null,
  enabled: boolean
): UseCalendarsResult {
  const api = apiService()
  const [calendars, setCalendars] = useState<CalendarOption[]>([])
  const [selectedId, setSelectedId] = useState<number | null>(null)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (!enabled || !integrationId) {
      setCalendars([])
      setSelectedId(null)
      return
    }

    let stale = false
    setLoading(true)
    void (async () => {
      const [err, data] = await to(api.calendars.getCalendars(integrationId))
      if (stale) return
      setLoading(false)
      if (err || !data) {
        toast.error('Failed to load calendars')
        return
      }
      setCalendars(data)
      const preSelected =
        data.find((c) => c.is_selected) ?? data.find((c) => c.is_primary)
      if (preSelected) {
        setSelectedId(preSelected.id)
      }
    })()

    return () => {
      stale = true
    }
  }, [enabled, integrationId])

  return { calendars, selectedId, setSelectedId, loading }
}
